export {
  pollsProptype,
  activePollProptype,
  pollQuestionProptype,
  choiceProptype,
} from "./PollProptypes";
